export default __webpack_public_path__ + "static/media/meslay5.e2cee24c.jpg";